$ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var ProductSorter = function () {

};

ProductSorter.prototype.init = function () {
	var self = this;

	$(document).on('facetwp-loaded', function() {
		if ('undefined' !== typeof FWP.extras.sort ) {
			$( '.facetwp-sort-radio input:radio[name="sort"]').filter('[value="'+FWP.extras.sort+'"]').prop("checked", true);
		}
	});
	// Sorting
	$(document).on('change', '.facetwp-sort-radio input', function() {
		FWP.extras.sort = $(this).val();
		FWP.soft_refresh = true;
		FWP.autoload();
	});

};

module.exports = new ProductSorter();